import React, {useReducer} from 'react';
import SessionStateContext from '../context/SessionStateContext';
import DispatchContext from '../context/DispatchContext';
import {reducer} from '../../reducer';

const initialSessionState = {
  nav_history: [],
  timestamp: new Date(),
  serviceRequestInsert: 0,
  serviceRequestLastFetch: {},
  serviceRequestUpdate: {},
  app_loading: false,
  user_settings: {},
  show_logout_dialog: false,
  show_tecrmi_dialog: null,
  messages: [],
};

let staticDispatch = null;

export const StaticDispatch = (...args) => {
  if (staticDispatch) {
    return staticDispatch(...args);
  }

  return undefined;
};

export const StaticState = {};

const syncStaticState = (sessionState) => {
  for (const key of Object.keys(StaticState)) {
    delete StaticState[key];
  }

  Object.assign(StaticState, sessionState);
};

const storeReducer = (state, action) => {
  const newState = reducer(state, action);
  return newState;
};

const withSessionState = (App) => {
  const WrappedApp = (props) => {
    const [sessionState, dispatch] = useReducer(
      storeReducer,
      initialSessionState,
    );

    staticDispatch = dispatch;
    syncStaticState(sessionState);

    return (
      <SessionStateContext.Provider value={sessionState}>
        <DispatchContext.Provider value={dispatch}>
          <App {...props} />
        </DispatchContext.Provider>
      </SessionStateContext.Provider>
    );
  };

  return WrappedApp;
};

export default withSessionState;
